import React, { useEffect, useState } from "react";
import { Users, Baby } from "lucide-react";
import api from "@/lib/api";

// Small "running total" strip shown on the Landing page — public read of
// /api/stats/public. Refetches every 30s so late payments show up without
// a full page reload during the days-long check-in period.
export default function PublicPaidTally() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      api
        .get("/stats/public")
        .then((r) => {
          if (!cancelled) setStats(r.data);
        })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 30000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!stats) return null;

  const adultsPct = stats.adults_total
    ? Math.round((stats.adults_paid / stats.adults_total) * 100)
    : 0;
  const kidsPct = stats.kids_total
    ? Math.round((stats.kids_paid / stats.kids_total) * 100)
    : 0;

  return (
    <div
      className="mt-6 grid grid-cols-2 gap-3 max-w-lg"
      data-testid="public-paid-tally"
    >
      <TallyCard
        icon={<Users className="h-4 w-4" />}
        eyebrow="Adults paid"
        value={`${stats.adults_paid} / ${stats.adults_total}`}
        pct={adultsPct}
        testid="tally-adults"
      />
      <TallyCard
        icon={<Baby className="h-4 w-4" />}
        eyebrow="Kids paid"
        value={`${stats.kids_paid} / ${stats.kids_total}`}
        pct={kidsPct}
        testid="tally-kids"
      />
    </div>
  );
}

function TallyCard({ icon, eyebrow, value, pct, testid }) {
  return (
    <div
      className="bg-white/90 backdrop-blur border border-[#e6e2d6] rounded-2xl px-4 py-3"
      data-testid={testid}
    >
      <div className="flex items-center gap-1.5 text-[10px] tracking-[0.16em] uppercase font-semibold text-[#8a7a3a]">
        {icon}
        {eyebrow}
      </div>
      <div className="mt-1 font-serif text-2xl text-stone-900 tabular-nums">
        {value}
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-[#faf7ef] overflow-hidden">
        <div
          className="h-full bg-[#1a2947] transition-[width] duration-700"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
